import React from 'react';
import './Impressum.css';

const PrivacyPolicy = () => {
  return (
    <div className="container my-5" style={{ maxWidth: 800 }}>
      <h1 className="mb-4">Privacy Policy</h1>
      <p><em>Last updated: February 2026</em></p>

      <h2 className="mt-4">1. Introduction</h2>
      <p>
        Vegbox GmbH (hereinafter "Vegbox", "we" or "us") operates the online shop at{' '}
        <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a>.
        The protection of your personal data is very important to us. This privacy policy explains
        which personal data we collect, how we use it, and what rights you have.
      </p>

      <h2 className="mt-4">2. Responsible Party</h2>
      <p>
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf, Switzerland<br />
        Email: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a><br />
        Phone: +41 78 222 42 36
      </p>

      <h2 className="mt-4">3. What Data Do We Collect?</h2>
      <p>We may collect the following personal data:</p>
      <ul>
        <li><strong>Master data:</strong> Name, address, email address, phone number</li>
        <li><strong>Order data:</strong> Ordered products, delivery address, delivery date and time, order history</li>
        <li><strong>Payment data:</strong> Payment method information (processed securely via Stripe — we do not store your credit card details)</li>
        <li><strong>Technical data:</strong> IP address, browser type, operating system, pages visited, access time</li>
        <li><strong>Communication data:</strong> Content of emails or contact form messages you send us</li>
      </ul>

      <h2 className="mt-4">4. For What Purposes Do We Use Your Data?</h2>
      <p>We use your personal data for the following purposes:</p>
      <ul>
        <li>Processing and delivering your orders</li>
        <li>Customer communication (order confirmations, delivery updates, support)</li>
        <li>Payment processing</li>
        <li>Improving our website and services</li>
        <li>Compliance with legal obligations</li>
      </ul>

      <h2 className="mt-4">5. Data Sharing</h2>
      <p>
        We share your personal data only where necessary for order fulfillment:
      </p>
      <ul>
        <li><strong>Stripe:</strong> For secure payment processing</li>
        <li><strong>Delivery partners:</strong> Name and address for delivery purposes</li>
      </ul>
      <p>
        We do not sell, trade, or otherwise transfer your personal data to third parties for marketing purposes.
      </p>

      <h2 className="mt-4">6. Cookies</h2>
      <p>
        Our website uses cookies to ensure its proper functioning. These include essential cookies for
        the shopping cart and user authentication. No tracking cookies for advertising purposes are used.
      </p>

      <h2 className="mt-4">7. Data Security</h2>
      <p>
        We take appropriate technical and organizational measures to protect your personal data against
        unauthorized access, loss, or misuse. However, we cannot guarantee absolute security
        of data transmitted over the internet.
      </p>

      <h2 className="mt-4">8. Data Retention</h2>
      <p>
        We retain your personal data only as long as necessary for the purposes stated above
        or as required by law (e.g. accounting retention periods of 10 years).
        After expiration of the retention periods, data is deleted or anonymized.
      </p>

      <h2 className="mt-4">9. Your Rights</h2>
      <p>You have the following rights regarding your personal data:</p>
      <ul>
        <li>Right to access your stored data</li>
        <li>Right to correction of inaccurate data</li>
        <li>Right to deletion of your data</li>
        <li>Right to restriction of data processing</li>
        <li>Right to data portability</li>
      </ul>
      <p>
        To exercise your rights, please contact us at{' '}
        <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>.
      </p>

      <h2 className="mt-4">10. Changes to This Privacy Policy</h2>
      <p>
        We may update this privacy policy from time to time. The current version is always
        available on our website. We recommend reviewing this policy periodically.
      </p>

      <h2 className="mt-4">11. Contact</h2>
      <p>
        If you have questions about data protection, please contact us:<br /><br />
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf<br />
        Email: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>
      </p>

      <p className="mt-4"><em>© 2026 Vegbox GmbH — All rights reserved</em></p>
    </div>
  );
};

export default PrivacyPolicy;